export const BREAKPOINTS = {
  SM: 768,
  MD: 1024,
  LG: 1200,
  XL: 1520,
} as const;
